export const VL_API_BASE_URL = import.meta.env.VITE_VL_API_BASE_URL;
export const VL_APP_BASE_URL = import.meta.env.VITE_VL_APP_BASE_URL;
export const VL_GRAPHQL_API_BASE_URL = import.meta.env.VITE_VL_GRAPHQL_API_BASE_URL;
export const VL_UI_BASE_URL = import.meta.env.VITE_VL_UI_BASE_URL;
